export default __webpack_public_path__ + "static/media/p75.4586ffb0.jpg";